export const filterNotNull = <T>(array: (T | null | undefined)[]): T[] => {
  return array.filter((x) => !!x).map((x) => x as T);
};
